import loadable from '@loadable/component'
import { useAuth } from 'hooks/use-auth'

const LazyAuth = loadable(() => import('routes/route-pages/auth'))
const LazyUnauth = loadable(() => import('routes/route-pages/unauth'))

export const App = () => {
  const { isAuthenticated, isInitial } = useAuth()

  if (isInitial) {
    return null
  }

  return isAuthenticated ? <LazyAuth /> : <LazyUnauth />
}
